"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.price = price;

/**
 * Formats a price for display.
 * @param {Number} price The price as a floating point number
 * @param {Object} options
 * @param {String} options.currency The currency code
 * @param {Number} options.decimals The number of decimal places to display
 * @param {String} options.locale The locale code
 * @return {String}
 */
function price(price) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$currency = _ref.currency,
      currency = _ref$currency === void 0 ? 'USD' : _ref$currency,
      _ref$decimals = _ref.decimals,
      decimals = _ref$decimals === void 0 ? 2 : _ref$decimals,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en-US' : _ref$locale;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: decimals
  }).format(price);
}
